import { css } from "@emotion/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "../components";
import PoliticaPrivacidadeConfirmar from "../components/politica-privacidade-confirmar";
import useUsuario from "../use-usuario";
import {
  dialogosInteligentes,
  spaikBeforeAuth,
  spaikIcon,
  spaik
} from "./../assets";
import { v } from "../util";
import Plataform from "../services/Plataform";

interface ConfirmProps {
  email: string;
}

const schema = v.object({
  email: v.string().superRefine(v.nonempty())
});

export default () => {
  const { userMail } = useParams();
  const { forgot } = useUsuario();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: userMail
    },
    resolver: zodResolver(schema)
  });

  return (
    <div
      className="grid grid-nogutter"
      css={css`
        height: 100vh;
      `}
    >
      <div
        className="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
        css={css`
          background-image: ${Plataform.customLogin ? "none" : "#2624CD"};
          background-color: ${Plataform.customLogin
            ? "#2624CD"
            : "transparent"};
          background-repeat: no-repeat;
          background-size: cover;
          display: flex;
          flex-direction: column;
          flex: 1;
          align-items: center;
          justify-content: center;
        `}
      >
        <div
          css={css`
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
          `}
        >
          <img
            src={spaikBeforeAuth}
            css={css`
              width: 600px;

              @media (width: 1600px) {
                width: 520px;
              }

              @media (max-width: 1400px) {
                width: 500px;
              }

              @media (max-width: 1280px) {
                width: 450px;
              }

              @media (max-width: 1200px) {
                width: 400px;
              }

              @media (max-width: 1050px) {
                width: 350px;
              }

              @media (max-width: 950px) {
                margin-top: 1rem;
              }
            `}
          />
        </div>

        <div
          css={css`
            padding-bottom: 16px;
            color: white;
          `}
        >
          <p>©{Plataform.displayName}</p>
        </div>
      </div>

      <div
        className="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6"
        css={css`
          display: flex;
          flex: 1;
          flex-direction: column;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            flex: 1;
            flex-direction: column;
            justify-content: center;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              gap: 16px;
              width: 500px;
            `}
          >
            <img
              src={Plataform.urlLogo ? Plataform.urlLogo : spaik}
              style={{ maxWidth: "70px", maxHeight: "70px" }}
            />
            <div>
              Enviamos um e-mail para&nbsp;
              <span
                css={css`
                  font-weight: 600;
                `}
              >
                {userMail} 😀
              </span>
            </div>
          </div>

          <div
            css={css`
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-top: 20px;
              gap: 20px;
              width: 500px;
            `}
          >
            <span>
              Verifique a sua caixa de entrada com instruções sobre como
              redefinir a sua senha.
            </span>
            <span>
              Não recebeu nenhum e-mail? Verifique o spam ou clique no botão
              abaixo.
            </span>
          </div>

          <div
            css={css`
              width: 500px;
            `}
          >
            <form
              onSubmit={handleSubmit(async (data) => {
                const { confirmationCode } = await forgot(data);
                navigate(`/confirm-reset-password/${data.email}`, {
                  replace: true
                });
              })}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 20px;
                `}
              >
                <Button
                  css={css`
                    width: 100%;
                    height: 45px;
                    margin-top: 20px;
                    background: #2624cd;
                  `}
                  label="Reenviar"
                />
                <div
                  css={css`
                    color: "#2624cd";
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                  `}
                >
                  <i
                    css={css`
                      color: #2624cd;
                    `}
                    className="pi pi-arrow-left"
                  ></i>
                  <Link to="/login">Voltar para o login</Link>
                </div>
              </div>
            </form>
          </div>
        </div>

        <PoliticaPrivacidadeConfirmar />
      </div>
    </div>
  );
};
